import { h } from 'preact'

import { PERMALINK_TITLE } from '../../../config'
import BackgroundTitle from '../../atom/BackgroundTitle'
import { SmartImgSettingsProvider } from '../../atom/nbb-smart-img'
import ArchiveNavigation from '../ArchiveNavigation'
import { AsSiteContentEntry } from '../SiteContent'
import { SIDE_CENTER, SIDE_LEFT } from '../../../constants'
import LinkWrapper from '../../atom/link-wrapper'

import { buildClassNames } from './classNames'
import { IMAGE_SETTINGS } from './img'
import { ArticleContentFooter } from './footer'

const ArticleContent = (props) => {
  const {
    class: _, // eslint-disable-line no-unused-vars
    children,
    className,
    meta = {},
    rel = {},
    ...rest
  } = props

  return (
    <article className={className}>
      <header className={buildClassNames({
        offsetSide: SIDE_LEFT,
        marginBottom: true,
      })}>
        <BackgroundTitle noMargin>
          <LinkWrapper
            title={PERMALINK_TITLE(meta.title)}
            href={meta.permalink}
            rel="bookmark"
          >
            {meta.title}
          </LinkWrapper>
        </BackgroundTitle>
      </header>

      <SmartImgSettingsProvider {...IMAGE_SETTINGS[SIDE_CENTER]}>
        <section className={buildClassNames({ narrow: true })}>
          {children}
        </section>
      </SmartImgSettingsProvider>

      <ArticleContentFooter meta={meta} {...rest} />

      <div className={buildClassNames({
        narrow: true,
        marginTop: true,
      })}>
        <ArchiveNavigation {...rel} />
      </div>
    </article>
  )
}

export const SiteArticleContent = AsSiteContentEntry(ArticleContent)

export default ArticleContent
